import React from "react";
import { Grid, CssBaseline, Stack, Box, Typography } from "@gti-controls-v2/web-core";
import loginStyles from "../../common/styles/Login";
import LogoRevolution from "../../assets/Logo-Revolution-White.svg"
import useTranslation from "../../hooks/useTranslation";

/** Estructura de Login */
export default function LoginLayout(props) {
  const styles = loginStyles;
  const { t } = useTranslation();

  return (
    <Grid container component="main" sx={styles.root}>
      <CssBaseline />

      <Stack direction="column" alignItems="center" width="100%">
        <Box sx={styles.imageContainer}>
          <Box
            component="img"
            src={LogoRevolution}
            alt="login"
            sx={styles.logo}
          />
        </Box>
        <Typography sx={styles.titleMonitor}>
          {t("sistema.login.titulos.monitorCafeteria")}
        </Typography>
        {props.children}
      </Stack>

    </Grid>
  );
}
